import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { filter, take } from 'rxjs';
import { SystemCategoryItem } from 'src/app/components/user-dashboard/product/models/course';
import { isCreateWebsiteCategoriesProcess, selectWebsiteCategories } from '../../store/_features/website/website.selector';
import { createWebsiteCategoriesActions, websiteCategoriesActions } from '../../store/_features/website/website.actions';
import { getSelectedIds, mapIdsToObjects } from '../../utils/ui/selector-value-adapter';
import { ToastrService } from 'ngx-toastr';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-category-selector',
  templateUrl: './category-selector.component.html',
  styleUrls: ['./category-selector.component.css'],
})
export class CategorySelectorComponent implements OnInit {

  @Input() set currentValue(val: SystemCategoryItem | SystemCategoryItem[] | number | number[] | null) {
    this._currentValue = val;
    this.updateSelectedIds();
  }
  get currentValue() {
    return this._currentValue;
  }
  private _currentValue: SystemCategoryItem | SystemCategoryItem[] | number | number[] | null = null;

  @Input() placeholder: string = 'Select Category';

  @Input() set multiple(val: boolean) {
    this._multiple = val;
    this.placeholder = val ? 'Select Categories' : 'Select Category';
    this.updateSelectedIds();
  }
  get multiple(): boolean {
    return this._multiple;
  }
  private _multiple: boolean = true;
  addingCategory: boolean = false;

  @Output() valueChange = new EventEmitter<SystemCategoryItem | SystemCategoryItem[]>();

  categoriesList: SystemCategoryItem[] = [];

  selectedIds: number[] = [];   // used only when multiple
  selectedId: number | null = null; // used only when single

  constructor(private store: Store, private toastr: ToastrService) {}

  ngOnInit() {
    this.store.dispatch(websiteCategoriesActions.load());

    this.store.select(selectWebsiteCategories)
      .pipe(filter(list => !!list?.length))
      .subscribe(categories => {
        this.categoriesList = categories;
        this.updateSelectedIds();
      });
  }

  private updateSelectedIds() {
    if (!this.categoriesList.length) return;

    const ids = getSelectedIds(this._currentValue);

    if (this.multiple) {
      this.selectedIds = ids;
      this.selectedId = null;
    } else {
      this.selectedId = ids.length ? ids[0] : null;
      this.selectedIds = [];
    }
  }

  onSelectValue(selected: number[] | number) {
    if (this.multiple) {
      this.selectedIds = selected as number[];
      const result = mapIdsToObjects(this.selectedIds, this.categoriesList, true);
      this._currentValue = result;
      this.valueChange.emit(result);
    } else {
      this.selectedId = selected as number;
      const result = mapIdsToObjects([this.selectedId], this.categoriesList, false)[0] ?? null;
      this._currentValue = result;
      this.valueChange.emit(result);
    }
  }


  
addCategoryPromise = (name: string): Promise<any> => {
  this.store.dispatch(
    createWebsiteCategoriesActions.create({
      payload: { name }
    })
  );

  this.addingCategory = true;

  return new Promise((resolve, reject) => {
    const sub = this.store.select(isCreateWebsiteCategoriesProcess).pipe(
      filter(process => process?.status === 'done' || process?.status === 'error'),
      take(1)
    )
    .subscribe({
      next: process => {
        this.addingCategory = false;

        if (process.status === 'done') {
          this.onCreateCategoryDone();
          resolve(process.lastAddedCategory ?? null);
        }
        else {
          this.onCreateCategoryError(process.error);
          reject(process.error);
        }
      },
      error: err => {
        this.addingCategory = false;
        reject(err);
      }
    });
  });
}

onCreateCategoryError(error: any) {
  this.toastr.error(error);
}

onCreateCategoryDone() {
  this.toastr.success("Created Successfully");
}
  
}
